export const resolveConfirmation = async (apiClient, {confirmationId, sessionId, email, items}) => {
  return apiClient.post(`/v1/confirmations/${confirmationId}/resolve`, {
    email,
    sessionId,
    items,
    sessionType: "trustedAdvisor",
  });
};

export const getConfirmation = async (apiClient, {confirmationId, sessionId}) => {
  return apiClient.post("/v1/confirmations/list", {
    sessionId,
    confirmationId,
    sessionType: "trustedAdvisor",
  });
};
